module.exports = __webpack_public_path__ + "assets/img/img30.6dd0e490.png";